import React, { useEffect, useState, forwardRef } from "react";
import Modal from "react-bootstrap/Modal";
import DropDownComp from "./DropDownComp";
import DateTimePicker from "react-datetime-picker";
import InputComp from "./InputComp";
import { useSelector } from "react-redux";
import CONSTANTS from "../util/constants";

const ModalComponent = (props) => {
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button className="example-custom-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  const [statusValue, setStatusValue] = useState(
    props.rowData && props.rowData.status
      ? { value: props.rowData.status, label: props.rowData.status }
      : ""
  );
  const [startDate, setStartDate] = useState(new Date());
  const loggedInUserDivision = useSelector(
    (state) => state.login.loginResponse.user.division
  );
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const isAdminUser = loginResponse?.user?.userRoles?.filter((data, i) => {
    return (
      data?.user_role_name === "ADMIN" || data?.user_role_name === "RHADMIN"
    );
  });
  const [location, setLocationValue] = useState(
    props.rowData && props.rowData.designationLocation
      ? {
          value: props.rowData.designationLocation,
          label: props.rowData.designationLocation,
        }
      : loggedInUserDivision.divisionName === "521"
      ? { value: "RH 521DC", label: "RH 521DC", isdisabled: false }
      : { value: "710", label: "710", isdisabled: false }
  );
  const [Id, setIdValue] = useState("");

  const [divisionTrailer, setDivisionTrailer] = useState("");
  const [rowData, setrowDataValue] = useState(
    props.rowData ? props.rowData : { Status: "", Condition: "", location: "" }
  );

  //User management
  const [firstName, setFirstName] = useState(
    props.rowDataUser && props.rowDataUser.firstName
      ? props.rowDataUser.firstName
      : ""
  );
  const [lastName, setLastName] = useState(
    props.rowDataUser && props.rowDataUser.lastName
      ? props.rowDataUser.lastName
      : ""
  );
  const [email, setEmail] = useState(
    props.rowDataUser && props.rowDataUser.email ? props.rowDataUser.email : ""
  );
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userId, setUserId] = useState("");
  const [useRole, setUserRole] = useState([]);
  const [role, setRole] = useState([]);

  //Door
  const [doorType, setDoorType] = useState(
    props.rowDataDoor && props.rowDataDoor.doorType
      ? { value: props.rowDataDoor.doorType, label: props.rowDataDoor.doorType }
      : ""
  );
  const [number, setDoorNumber] = useState(
    props.rowDataDoor && props.rowDataDoor.number
      ? props.rowDataDoor.number
      : ""
  );
  const [doorDivisionId, setDoorDivisionId] = useState(
    props.rowDataDoor && props.rowDataDoor.divisionName
      ? {
          label: props.rowDataDoor.divisionName,
          value: props.rowDataDoor.division_id,
        }
      : ""
  );
  //Division
  const [divisionId, setDivisionId] = useState(
    props.rowDataDivision && props.rowDataDivision.division_id
      ? props.rowDataDivision.division_id
      : ""
  );
  const [divisionName, setDivisionName] = useState(
    props.rowDataDivision && props.rowDataDivision.divisionName
      ? props.rowDataDivision.divisionName
      : ""
  );
  //Lots
  const [lotName, setLotsName] = useState(
    props.rowDataLot && props.rowDataLot.lotName ? props.rowDataLot.lotName : ""
  );
  const [lotDivisionId, setLotDivisionId] = useState(
    props.rowDataLot && props.rowDataLot.divisionName
      ? {
          label: props.rowDataLot.divisionName,
          value: props.rowDataLot.divisionId,
        }
      : ""
  );
  const [lotId, setLotId] = useState(
    props.rowDataLot && props.rowDataLot.lot_id ? props.rowDataLot.lot_id : ""
  );
  let divisionsArrayTemp = useSelector(
    (state) => state.division.getDivisionData
  );
  divisionsArrayTemp = divisionsArrayTemp.filter((data, i) => {
    return data?.is_active === true;
  });
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );
  const [divisionsArray, setDivisionArray] = useState([]);
  const [divisionsArray2, setDivisionArray2] = useState([]);
  //User management division
  const [userDivisionName, setUserDivisionName] = useState(
    props.rowDataUser && props.rowDataUser.divisions
      ? {
          label: props.rowDataUser.divisions?.divisionName,
          value: props.rowDataUser.divisions?.division_id,
        }
      : ""
  );
  const userRoles = useSelector((state) => state.login.loginRolesData);

  useEffect(() => {
    if (props.rowData) {
      setIdValue(props.rowData.btId);
    }
    if (props.rowDataUser) {
      setUserId(props.rowDataUser.user_id);
    }

    if (props.roles) {
      var data = [];
      for (var i = 0; i < props.roles.length; i++) {
        data.push({
          label: props.roles[i].user_role_name,
          value: props.roles[i].user_role_id,
        });
      }
      setUserRole(data);
    }

    if (divisionsArrayTemp) {
      var data = [];
      var data2 = [];
      if (props.rowData && props.rowData?.division_id != null) {
        let divisionTemp = divisionsArrayTemp?.filter((obj) => {
          return obj.division_id == props.rowData?.division_id;
        });
        setDivisionTrailer({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        setDoorDivisionId({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        setLotDivisionId({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        setUserDivisionName({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        if (userRoles && userRoles.length > 0 && !userRoles[0].is_user) {
          for (var i = 0; i < divisionsArrayTemp.length; i++) {
            if (
              divisionsArrayTemp[i].division_id == props.rowData?.division_id
            ) {
              data.push({
                label: divisionsArrayTemp[i].divisionName,
                value: divisionsArrayTemp[i].division_id,
                isdisabled: false,
              });
              data2.push({
                label: divisionsArrayTemp[i].divisionName,
                value: divisionsArrayTemp[i].division_id,
                isdisabled: false,
              });
            } else {
              data.push({
                label: divisionsArrayTemp[i].divisionName,
                value: divisionsArrayTemp[i].division_id,
                isdisabled: true,
              });
              data2.push({
                label: divisionsArrayTemp[i].divisionName,
                value: divisionsArrayTemp[i].division_id,
                isdisabled: false,
              });
            }
          }
          setDivisionArray(data);
          setDivisionArray2(data2);
        } else {
          for (var i = 0; i < divisionsArrayTemp?.length; i++) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
            });
            data2.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
            });
          }
          setDivisionArray(data);
          setDivisionArray2(data2);
        }
      }
      if (props.rowDataUser && props.rowDataUser?.division_id != null) {
        let divisionTemp = divisionsArrayTemp?.filter((obj) => {
          return obj.division_id == props.rowDataUser?.division_id;
        });
        setDivisionTrailer({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        setDoorDivisionId({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        setLotDivisionId({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        setUserDivisionName({
          value: divisionTemp[0].division_id,
          label: divisionTemp[0].divisionName,
        });
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (
            divisionsArrayTemp[i].division_id == props.rowDataUser?.division_id
          ) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
            data2.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          } else {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
            data2.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          }
        }
        setDivisionArray(data);
        setDivisionArray2(data2);
      } else if (
        divisionSelectedTemp &&
        divisionSelectedTemp != null &&
        divisionSelectedTemp != ""
      ) {
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (divisionsArrayTemp[i].division_id == divisionSelectedTemp.value) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
            data2.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          } else {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
            data2.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          }
        }
        setDivisionArray(data);
        setDivisionArray2(data2);
        setDivisionTrailer(divisionSelectedTemp);
        setDoorDivisionId(divisionSelectedTemp);
        setLotDivisionId(divisionSelectedTemp);
        setUserDivisionName(divisionSelectedTemp);
      } else {
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          data.push({
            label: divisionsArrayTemp[i].divisionName,
            value: divisionsArrayTemp[i].division_id,
          });
        }
        setDivisionArray(data);
        setDivisionArray2(data);
      }
    } else {
      setDivisionTrailer(divisionSelectedTemp);
      setDoorDivisionId(divisionSelectedTemp);
      setLotDivisionId(divisionSelectedTemp);
    }

    if (
      props.rowDataUser &&
      props.rowDataUser.userRoles &&
      props.rowDataUser.userRoles.length > 0
    ) {
      var data = [];
      for (var i = 0; i < props.rowDataUser.userRoles.length; i++) {
        data.push({
          label: props.rowDataUser.userRoles[i].user_role_name,
          value: props.rowDataUser.userRoles[i].user_role_id,
        });
      }
      setRole(data);
    }
  }, []);

  return (
    <Modal
      size="m"
      show={props.isShow}
      onHide={props.handleClose}
      backdrop="static"
      centered
      keyboard={false}
    >
      <Modal.Header style={{ backgroundColor: "rgb(0, 42, 74)" }}>
        <Modal.Title style={{ fontFamily: "Roboto", color: "white" }}>
          {props.title}
        </Modal.Title>
      </Modal.Header>

      {props.addUserManagement || props.driverManagement ? (
        <Modal.Body>
          <div className="container ">
            <div className="row">
              <div className="d-flex f-direction-row ">
                <div className="col-md-4">
                  <label style={{ fontSize: 16, marginRight: 12 }}>
                    First Name
                  </label>
                </div>
                <div className="col-md-6">
                  <InputComp
                    style={{
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"First Name"}
                    maxLength={30}
                    placeholder={"First Name"}
                    value={firstName}
                    onChangeHandler={(firstName) => {
                      setFirstName(firstName);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="row">
              <div className="d-flex f-direction-row align-items-center mt-3 ">
                <div className="col-md-4">
                  <label style={{ fontSize: 16, marginRight: 12 }}>
                    Last Name
                  </label>
                </div>
                <div className="col-md-6">
                  <InputComp
                    style={{
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",

                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Last Name"}
                    maxLength={30}
                    placeholder={"Last Name"}
                    value={lastName}
                    onChangeHandler={(lastName) => {
                      setLastName(lastName);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="row">
              <div className="d-flex f-direction-row align-items-center mt-3 ">
                <div className="col-md-4">
                  <label style={{ fontSize: 16, marginRight: 12 }}>Email</label>
                </div>
                <div className="col-md-6">
                  <InputComp
                    style={{
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",

                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Email"}
                    maxLength={80}
                    placeholder={"Email"}
                    value={email}
                    onChangeHandler={(Email) => {
                      setEmail(Email);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="row">
              <div className="d-flex f-direction-row align-items-center mt-3 ">
                <div className="col-md-4">
                  <label style={{ fontSize: 16, marginRight: 12 }}>
                    Password
                  </label>
                </div>
                <div className="col-md-6">
                  <InputComp
                    style={{
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",

                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Password"}
                    maxLength={12}
                    placeholder={"Password"}
                    value={password}
                    onChangeHandler={(Password) => {
                      setPassword(Password);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="row">
              <div className="d-flex f-direction-row align-items-center mt-3 ">
                <div className="col-md-4">
                  <label style={{ fontSize: 16, marginRight: 12 }}>
                    Confirm Password
                  </label>
                </div>
                <div className="col-md-6">
                  <InputComp
                    style={{
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",

                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Confirm Password"}
                    maxLength={12}
                    placeholder={"Confirm Password"}
                    value={confirmPassword}
                    onChangeHandler={(ConfirmPassword) => {
                      setConfirmPassword(ConfirmPassword);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="d-flex f-direction-row align-items-center mt-3 ">
                <div className="col-md-4">
                  <label style={{ fontSize: 16, marginRight: 12 }}>
                    {"Division Name"}
                  </label>
                </div>
                <div className="col-md-6">
                  <DropDownComp
                    styles={{
                      display: "flex",
                      flexDirection: "row",
                      alignSelf: "center",
                      alignItems: "center",
                      justifyContent: "center",

                      height: 35,
                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                    }}
                    name={"Select Division Name"}
                    options={divisionsArray}
                    onChange={(value) => {
                      setUserDivisionName(value);
                    }}
                    value={userDivisionName}
                  />
                </div>
              </div>
            </div>
          </div>

          {props.driverManagement ? null : (
            <div className="container ">
              <div className="row">
                <div className="d-flex f-direction-row align-items-center mt-3 ">
                  <div className="col-md-4">
                    <label style={{ fontSize: 16, marginRight: 12 }}>
                      User Roles:
                    </label>
                  </div>

                  <div className="col-md-6">
                    <DropDownComp
                      styles={{
                        display: "flex",
                        flexDirection: "row",

                        width: "95%",
                        height: 35,
                        padding: 2,
                        borderColor: "hsl(0, 0%, 50%)",

                        borderStyle: "solid",
                        borderWidth: "1px",
                      }}
                      name={"Select User Role"}
                      isMulti={true}
                      options={useRole}
                      onChange={(value) => {
                        setRole(value);
                        setrowDataValue((previos) => ({
                          ...previos,
                          permision: value,
                        }));
                      }}
                      value={role}
                      //&& props.rowData != 'null' ? props.rowData.Status : 'Active'
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      ) : props.doorManagement ? (
        <Modal.Body>
          <div className="container mt-3 row d-flex f-direction-row ">
            <div className="col-12 col-lg-5 col-md-5 col-sm-12">
              <label style={{ fontSize: 16, marginRight: 12 }}>
                {"Division Name"}
              </label>
            </div>
            <div className="col-12 col-lg-6 col-md-6 col-sm-12">
              <DropDownComp
                styles={{
                  display: "flex",
                  flexDirection: "row",
                  alignSelf: "center",
                  alignItems: "center",
                  justifyContent: "center",

                  height: 35,
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                }}
                name={"Select Division Name"}
                options={divisionsArray}
                onChange={(value) => {
                  setDoorDivisionId(value);
                }}
                value={doorDivisionId}
              />
            </div>
          </div>

          <div className="container row d-flex f-direction-row align-items-center mt-3 ">
            <div className="col-12 col-sm-12 col-lg-5 col-md-5">
              <label style={{ fontSize: 16, marginRight: 12 }}>
                {"Door Type"}
              </label>
            </div>

            <div className="col-12 col-sm-12 col-lg-6 col-md-6">
              <DropDownComp
                styles={{
                  display: "flex",
                  flexDirection: "row",

                  width: "100%",
                  height: 35,
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                }}
                name={"Door Type"}
                options={[
                  { value: "Receiving", label: "Receiving" },
                  { value: "Shipping", label: "Shipping" },
                  { value: "Supply", label: "Supply" },
                ]}
                onChange={(value) => {
                  setDoorType(value);
                  setDoorType((previos) => ({ ...previos, doorType: value }));
                }}
                value={doorType}
              />
            </div>
          </div>

          <div className="row container d-flex f-direction-row mt-4">
            <div className="col-12 col-sm-12 col-lg-5 col-md-5">
              <label style={{ fontSize: 16 }}>Door Number</label>
            </div>
            <div className="col-12 col-sm-12 col-lg-6 col-md-6">
              <InputComp
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  padding: "4px",
                  fontSize: 14,
                }}
                labelName={"Door Number"}
                maxLength={30}
                placeholder={"Door Number"}
                value={number}
                onChangeHandler={(doorNumber) => {
                  setDoorNumber(doorNumber);
                }}
              />
            </div>
          </div>
        </Modal.Body>
      ) : props.divisionManagement ? (
        <Modal.Body>
          {props.rowDataDivision != null ? (
            <div className="row container d-flex f-direction-row ">
              <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                <label style={{ fontSize: 16, marginRight: 12 }}>
                  {"Division Id"}
                </label>
              </div>
              <div className="col-12 col-lg-6 col-md-6 col-sm-12">
                <InputComp
                  style={{
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    padding: "4px",
                    fontSize: 14,
                  }}
                  labelName={"Division Id"}
                  maxLength={30}
                  placeholder={"Division Id"}
                  value={divisionId}
                  onChangeHandler={(divisionId) => {
                    setDivisionId(divisionId);
                  }}
                />
              </div>
            </div>
          ) : null}
          <div className="row container mt-4 d-flex f-direction-row ">
            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
              <label style={{ fontSize: 16 }}>{"Division Name"}</label>
            </div>
            <div className="col-12 col-lg-6 col-md-6 col-sm-12">
              <InputComp
                style={{
                  display: "flex",
                  flexDirection: "row",

                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  padding: "4px",
                  fontSize: 14,
                }}
                labelName={"Division Name"}
                maxLength={30}
                placeholder={"Division Name"}
                value={divisionName}
                onChangeHandler={(divisionName) => {
                  setDivisionName(divisionName);
                }}
              />
            </div>
          </div>
        </Modal.Body>
      ) : props.lotManagement ? (
        <Modal.Body>
          <div className="container row d-flex f-direction-row ">
            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
              <label style={{ fontSize: 16, marginRight: 12 }}>
                {"Yard Name"}
              </label>
            </div>
            <div className="col-12 col-lg-6 col-md-6 col-sm-12">
              <InputComp
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",

                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  padding: "4px",
                  fontSize: 14,
                }}
                labelName={"Yard Name"}
                maxLength={30}
                placeholder={"Yard Name"}
                value={lotName}
                onChangeHandler={(lotName) => {
                  setLotsName(lotName);
                }}
              />
            </div>
          </div>

          <div className="container mt-3 row d-flex f-direction-row ">
            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
              <label style={{ fontSize: 16, marginRight: 12 }}>
                {"Division Name"}
              </label>
            </div>
            <div className="col-12 col-lg-6 col-md-6 col-sm-12">
              <DropDownComp
                styles={{
                  display: "flex",
                  flexDirection: "row",
                  alignSelf: "center",
                  alignItems: "center",
                  justifyContent: "center",

                  height: 35,
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                }}
                name={"Division Id"}
                options={divisionsArray}
                onChange={(value) => {
                  setLotDivisionId(value);
                }}
                value={lotDivisionId}
              />
            </div>
          </div>
        </Modal.Body>
      ) : (
        <Modal.Body>
          <div className="container ">
            <div className="row d-flex f-direction-row ">
              <div className="col-3 col-lg-3 col-md-3 col-sm-3">
                <label style={{ fontSize: 16 }}>Id:</label>
              </div>
              <div className="col-6 col-lg-6 col-md-6 col-sm-6">
                <InputComp
                  style={{
                    width: "100%",
                    display: "flex",
                    alignSelf: "center",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    padding: "4px",
                  }}
                  labelName={"Id"}
                  maxLength={20}
                  placeholder={"Id"}
                  value={Id}
                  onChangeHandler={(Id) => {
                    setIdValue(Id);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="row d-flex f-direction-row align-items-center mt-3 ">
              <div className="col-3 col-lg-3 col-md-3 col-sm-3">
                <label style={{ fontSize: 16 }}>Status:</label>
              </div>

              <div className="col-6 col-lg-6 col-md-6 col-sm-6">
                <DropDownComp
                  styles={{
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "center",
                    alignItems: "center",
                    justifyContent: "center",

                    height: 35,
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                  }}
                  name={"Status"}
                  options={[
                    { value: "ACTIVE", label: "Active" },
                    { value: "INACTIVE", label: "InActive" },
                  ]}
                  onChange={(value) => {
                    setStatusValue(value);
                    setrowDataValue((previos) => ({
                      ...previos,
                      Status: value,
                    }));
                  }}
                  value={statusValue}
                />
              </div>
            </div>
          </div>

          {props.title === "Edit Trailer" ||
          props.title === "Add trailer" ? null : (
            <div className="container">
              <div className="row d-flex f-direction-row align-items-center">
                <div className="col-3 col-lg-3 col-md-3 col-sm-3">
                  <label style={{ fontSize: 16 }}>Location:</label>
                </div>
                <div className="col-6 col-lg-6 col-md-6 col-sm-6">
                  <DropDownComp
                    styles={{
                      display: "flex",
                      flexDirection: "row",
                      alignSelf: "center",
                      alignItems: "center",
                      justifyContent: "center",

                      height: 35,
                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                    }}
                    name={"Location"}
                    options={[
                      ...(divisionSelectedTemp?.label === "521"
                        ? [
                            {
                              value: "RH 521DC",
                              label: "RH 521DC",
                              isdisabled: false,
                            },
                          ]
                        : [
                            { value: "710", label: "710" },
                            { value: "701", label: "701" },
                          ]),
                      { value: "HQ", label: "HQ", isdisabled: true },
                      {
                        value: "MASTERLIST",
                        label: "Master List",
                        isdisabled: true,
                      },
                    ]}
                    onChange={(value) => {
                      setLocationValue(value);
                    }}
                    value={location}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="container">
            <div className="row d-flex f-direction-row align-items-center  ">
              <div className="col-3 col-sm-3 col-md-3 col-lg-3">
                <label style={{ fontSize: 16, marginRight: 12 }}>
                  Date Entered:
                </label>
              </div>
              <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                <style>
                  {`.date-picker input {
                    width: 100% 
                    height:70%
                          }`}
                </style>
                <DateTimePicker
                  className="d-flex w-80 h-100"
                  customInput={<ExampleCustomInput />}
                  wrapperClassName="date-picker"
                  value={rowData.startDate || startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row d-flex f-direction-row align-items-center  ">
              <div className="col-3 col-sm-3 col-md-3 col-lg-3">
                <label style={{ fontSize: 16, marginRight: 12 }}>
                  Division:
                </label>
              </div>
              {console.log("divisionsArray2", divisionsArray2)}
              <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                <style>
                  {`.date-picker input {
                    width: 100% 
                    height:70%
                          }`}
                </style>
                <DropDownComp
                  styles={{
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "center",
                    alignItems: "center",
                    justifyContent: "center",

                    height: 35,
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                  }}
                  name={"Select Division Name"}
                  options={
                    isAdminUser?.length > 0 ? divisionsArray2 : divisionsArray
                  }
                  onChange={(value) => {
                    setUserDivisionName(value);
                  }}
                  value={userDivisionName}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      )}

      <Modal.Footer>
        <div
          className="row col-12 col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              onClick={() => {
                if (props.addUserManagement) {
                  if (firstName == "") {
                    alert("Please enter First Name");
                  } else if (lastName == "") {
                    alert("Please enter Last Name");
                  } else if (email == "") {
                    alert("Please enter Email");
                  } else if (password == "" && !props?.rowDataUser) {
                    alert("Please enter Password");
                  } else if (confirmPassword == "" && !props?.rowDataUser) {
                    alert("Please enter Confirm Password");
                  } else if (confirmPassword != password) {
                    alert("Confirm Password does not match with Password");
                  } else {
                    let roleValue = [],
                      obj = {},
                      isAdminUser = false;
                    if (props.rowDataUser != null) {
                      for (let i = 0; i < role?.length; i++) {
                        if (role[i].value == 1) {
                          isAdminUser = true;
                        }
                        roleValue.push(role[i].value);
                      }
                      //admin user role : division_id null
                      if (isAdminUser) {
                        obj = {
                          id: userId,
                          email: email,
                          firstName: firstName,
                          lastName: lastName,
                          password: password,
                          permissions: roleValue,
                        };
                      } else {
                        obj = {
                          id: userId,
                          email: email,
                          firstName: firstName,
                          lastName: lastName,
                          password: password,
                          permissions: roleValue,
                          division_id: userDivisionName?.value?.toString(),
                        };
                      }
                      props.setValue(obj);
                    } else {
                      for (let i = 0; i < role?.length; i++) {
                        if (role[i].value == 1) {
                          isAdminUser = true;
                        }
                        roleValue.push(role[i].value);
                      }
                      if (isAdminUser) {
                        obj = {
                          email: email,
                          firstName: firstName,
                          lastName: lastName,
                          password: password,
                          permissions: roleValue,
                        };
                      } else {
                        obj = {
                          email: email,
                          firstName: firstName,
                          lastName: lastName,
                          password: password,
                          permissions: roleValue,
                          division_id: userDivisionName?.value?.toString(),
                        };
                      }
                      props.setValue(obj);
                    }
                  }
                } else if (props.driverManagement) {
                  if (firstName == "") {
                    alert("Please enter First Name");
                  } else if (lastName == "") {
                    alert("Please enter Last Name");
                  } else if (email == "") {
                    alert("Please enter Email");
                  } else if (password == "" && !props?.rowDataUser) {
                    alert("Please enter Password");
                  } else if (confirmPassword == "" && !props?.rowDataUser) {
                    alert("Please enter Confirm Password");
                  } else if (confirmPassword != password) {
                    alert("Confirm Password does not match with Password");
                  } else {
                    let driverRoles;
                    if (userRoles && userRoles?.length > 0) {
                      driverRoles = userRoles?.filter((item) => {
                        return (
                          item.user_role_name ==
                          CONSTANTS.CONSTANTS_USER_ROLES.DRIVER
                        );
                      });
                    }

                    if (props.rowDataUser != null) {
                      let obj = {
                        id: userId,
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        password: password,
                        permissions: [driverRoles[0]?.user_role_id],
                        division_id: divisionTrailer?.value,
                      };
                      props.setValue(obj);
                    } else {
                      let obj = {
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        password: password,
                        permissions: [driverRoles[0]?.user_role_id],
                        division_id: divisionTrailer?.value,
                      };
                      props.setValue(obj);
                    }
                  }
                } else if (props.doorManagement) {
                  if (doorType == "") {
                    alert("Please Enter Door Name");
                  } else if (number == "") {
                    alert("Please Enter Door Number ");
                  } else {
                    let obj = {
                      door_id: props.rowDataDoor
                        ? props.rowDataDoor.door_id
                        : "",
                      doorType: doorType,
                      number: number,
                      divisionId: doorDivisionId.value,
                    };
                    props.setValue(obj);
                  }
                } else if (props.divisionManagement) {
                  if (divisionName == "") {
                    alert("Please Enter Division Name");
                  } else {
                    let obj = {
                      division_id: divisionId,
                      divisionName: divisionName,
                    };
                    props.setValue(obj);
                  }
                } else if (props.lotManagement) {
                  if (lotName == "") {
                    alert("Please Enter Yard Name");
                  } else {
                    let obj = {
                      lotName: lotName,
                      division_id: parseInt(lotDivisionId?.value),
                      lot_id: lotId,
                    };
                    props.setValue(obj);
                  }
                } else {
                  if (Id == "") {
                    alert("Please Enter Id ");
                  } else if (location == "") {
                    alert("Please Select location ");
                  } else if (statusValue == "") {
                    alert("Please Select Status ");
                  } else if (userDivisionName == "") {
                    alert("Please Select Division ");
                  } else {
                    let obj = {
                      id: rowData.id,
                      btId: Id,
                      status: statusValue?.value,
                      designationLocation: location.value,
                      purchaseDate: new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      }).format(startDate),
                      division_id: userDivisionName?.value,
                    };
                    props.setValue(obj);
                  }
                }
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {props.lotManagement && props.rowDataLot
                ? "Edit Yard"
                : props.lotManagement
                ? "Add Yard"
                : props.divisionManagement && props.rowDataDivision
                ? "Edit division"
                : props.divisionManagement
                ? "Add Division"
                : props.doorManagement && props.rowDataDoor
                ? "Edit Door"
                : props.doorManagement
                ? "Add Door"
                : props.addUserManagement && props.rowDataUser
                ? "Edit User"
                : props.addUserManagement
                ? "add User"
                : props.driverManagement && props.rowDataUser
                ? "Edit Driver"
                : props.driverManagement
                ? "Add Driver"
                : props.rowData
                ? "Edit Trailer"
                : "Create New Trailer"}
            </button>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              onClick={() => {
                props.show(false);
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {"Cancel"}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalComponent;
